import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Events from '@/hooks/events';
import actions from '../constants';

const useToggleSubscription = (event) => {
  const handler = useDispatch();
  return useCallback(() => handler({ type: actions.TOGGLE_SUBSCRIPTION, event }), [event]);
};

export default {
  useToggleSubscription,
  useToggleShowSubscription: () => Events.useSimpleDispatch(actions.TOGGLE_SHOW_SUBSCRIPTION),
};
